import { render } from "./CourseShortCard.vue?vue&type=template&id=51b067d9&scoped=true"
import script from "./CourseShortCard.vue?vue&type=script&lang=js"
export * from "./CourseShortCard.vue?vue&type=script&lang=js"

import "./CourseShortCard.vue?vue&type=style&index=0&id=51b067d9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b067d9"]])

export default __exports__